import gql from 'graphql-tag'

export default gql`
mutation createEvent($record: CreateOneEventInput!){
    createEvent(record:$record){
      recordId
    }
  }
`
